<template>
  <nav>
    <v-card
      max-width="960px"
      elevation="0"
      class="mx-auto fill-height pa-5"
      align="center"
      color="background"
    >
      <v-row
        class="fill-height"
        align="center"
      >
        <v-col
          fill-height
          align="center"
        >
          <v-img
            :src="require('../../assets/image3.png')"
            width="100%"
            max-width="400px"
            class="mx-auto mb-10"
          />
          <p class="text-h5 font-weight-bold">
            {{ $t('spaceNotExistTitle') }}
          </p>
          <p class="text-body-1">
            {{ $t('spaceNotExistText') }}
          </p>
        </v-col>
      </v-row>
    </v-card>
  </nav>
</template>
<script>

export default {
    async beforeRouteEnter(to, from, next) {
        if(from.name == null){
            next({
                path: '/',
            })
        }
        next();
    }
    
}
</script>
